import { useState, useEffect } from 'react'
import { UAParser } from 'ua-parser-js'
import { eventTracker } from '@/config/trackingFunctions'
import { TRACKING_TYPES } from '@/constants/TrackingConstants'
import { useRemoteConfig } from '@/hooks/useRemoteConfig'
import CloseIcon from '@/assets/icons/close.svg?react'

export const MobileAppBanner = () => {
  const { device, os } = UAParser()
  const isMobile = device.is('mobile')
  const isIOS = os.is('iOS')
  const isAndroid = os.is('Android')
  const isSupportedOS = isIOS || isAndroid

  const { getBoolean, isReady } = useRemoteConfig()
  const enableMobileAppBanner = getBoolean('enableMobileBrowserAppBanner', false)

  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const isBannerClosed = localStorage.getItem('duprAppBannerClosed') === 'true'

    if (isMobile && isSupportedOS && !isBannerClosed) {
      setIsVisible(true)

      // We can optionally a new tracking type is added for banner visibility
      // eventTracker(TRACKING_TYPES.MOBILE_APP_BANNER_SHOWN)
    }
  }, [isMobile, isSupportedOS])

  const handleClose = () => {
    setIsVisible(false)

    // Also set in localStorage so we remember the user has already closed the banner
    try {
      localStorage.setItem('duprAppBannerClosed', 'true')
    } catch (error) {
      console.error('Could not access localStorage:', error)
    }
  }

  const handleGetAppClick = () => {
    if (isIOS) {
      eventTracker(TRACKING_TYPES.DOWNLOAD_APPLE_APP)
    } else if (isAndroid) {
      eventTracker(TRACKING_TYPES.DOWNLOAD_ANDROID_APP)
    }
  }

  const appStoreUrl = isIOS
    ? 'https://apps.apple.com/us/app/dupr/id1567932355'
    : 'https://play.google.com/store/apps/details?id=gg.dupr'
  const osText = isIOS ? 'Free app for iPhone' : 'Free app for Android'

  if (isVisible && isReady) {
    if (enableMobileAppBanner) {
      return (
        <div className="relative top-0 left-0 right-0 z-50 bg-gray-50 shadow-md font-sans p-2">
          <div className="flex items-center space-x-3">
            <button onClick={handleClose} className="text-gray-400 hover:text-gray-600" aria-label="Close app banner">
              <CloseIcon />
            </button>

            <div className="flex-shrink-0 w-14 h-14 bg-blue-600 rounded-xl flex items-center justify-center">
              <span className="text-white text-3xl font-bold">D</span>
            </div>

            <div className="flex-grow min-w-0">
              <p className="font-bold text-gray-900 text-base">DUPR</p>
              <p className="text-sm text-gray-600">{osText}</p>
            </div>

            <a
              href={appStoreUrl}
              type="button"
              onClick={handleGetAppClick}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-3 py-1.5 rounded-md text-sm ml-3"
            >
              GET APP
            </a>
          </div>
        </div>
      )
    }
  }

  return null
}
